import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

type LpStageBandProps = {
  stageUrl: string;
};

export default function LpStageBand({ stageUrl }: LpStageBandProps) {
  const ref = useRevealOnScroll<HTMLDivElement>();
  return (
    <section className="stageband" aria-label="Stage">
      <div className="stageband__media">
        <img src={stageUrl} alt="" />
      </div>
      <div className="stageband__scrim" />
      <div ref={ref} className="wrap stageband__inner reveal">
        <span className="eyebrow"><span className="dot" />{t('landingPage.v2.stageBand.eyebrow')}</span>
        <p className="stageband__line">{t('landingPage.v2.stageBand.line')}</p>
        <p className="stageband__cap">{t('landingPage.v2.stageBand.cap')}</p>
      </div>
    </section>
  );
}
